import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { EvaluatorTestSetDetailPage } from "@/features/evaluator-operations/test-sets/evaluator-test-set-detail-page";
import { CALIBRATION_TEST_SET_VALUES } from "@/features/evaluator-operations/types";

export const Route = createFileRoute("/evaluators/test-sets/$testSetId")({
  validateSearch: z.object({
    version: z.coerce.number().int().positive().optional(),
    category: z.enum(CALIBRATION_TEST_SET_VALUES).optional(),
  }),
  component: () => (
    <PermissionGuard module="evaluators">
      <EvaluatorTestSetDetailPage />
    </PermissionGuard>
  ),
});
